import { useMemo } from 'react'
import { useIntl } from 'react-intl'

interface CarHireSearchLabels {
  pickUpDropOffLocationTitle: string
  pickUpLocationTitle: string
  dropOffLocationTitle: string
  pickUpLocationPlaceholder: string
}

/**
 * Returns localized labels for car hire location search inputs.
 * This hook should be used instead of the constants in constants/carHire.ts
 * for user-facing label strings.
 */
function useCarHireSearchLabels(): CarHireSearchLabels {
  const intl = useIntl()

  return useMemo(() => ({
    pickUpDropOffLocationTitle: intl.formatMessage({
      id: 'p5t2hM/oAk',
      defaultMessage: 'Pick-up & Drop-off location',
      description: 'Title for car hire combined pick-up and drop-off location search',
    }),
    pickUpLocationTitle: intl.formatMessage({
      id: '8hvFvJwS2T',
      defaultMessage: 'Pick-up location',
      description: 'Title for car hire pick-up location search in the search interface',
    }),
    dropOffLocationTitle: intl.formatMessage({
      id: '5t9IbFK/9c',
      defaultMessage: 'Drop-off location',
      description: 'Title for car hire drop-off location search in the search interface',
    }),
    pickUpLocationPlaceholder: intl.formatMessage({
      id: '2o5MCUK92O',
      defaultMessage: 'Search for an airport or city',
      description: 'Placeholder for car hire location search input on the form',
    }),
  }), [intl])
}

export default useCarHireSearchLabels
